import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Nosotros from "../pages/nosotros/page";
import Servicios from "../pages/servicios/page";
import Proyectos from "../pages/proyectos/page";
import Instalaciones from "../pages/instalaciones/page";
import Contacto from "../pages/contacto/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/nosotros",
    element: <Nosotros />,
  },
  {
    path: "/servicios",
    element: <Servicios />,
  },
  {
    path: "/proyectos",
    element: <Proyectos />,
  },
  {
    path: "/instalaciones",
    element: <Instalaciones />,
  },
  {
    path: "/contacto",
    element: <Contacto />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;